export default __webpack_public_path__ + "static/media/logo-ghs-full-width.f5ed1807.svg";